(function () {
  var sourceSelector = '[data-sparklayer-loyaltylion-points-source]';
  var targetSelector =
    '.my-account__loyalty [data-lion-points], .my-cart__loyalty [data-lion-points]';
  var observedRoots = [];
  var syncScheduled = false;

  function findInOpenShadowRoots(root, selector, results) {
    var matches = root.querySelectorAll(selector);

    matches.forEach(function (match) {
      results.push(match);
    });

    root.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) {
        observeRoot(element.shadowRoot);
        findInOpenShadowRoots(element.shadowRoot, selector, results);
      }
    });
  }

  function syncPoints() {
    var source = document.querySelector(sourceSelector);
    if (!source || source.textContent.trim() === '') return;

    var targets = [];
    findInOpenShadowRoots(document, targetSelector, targets);

    targets.forEach(function (target) {
      if (target.textContent.trim() !== source.textContent.trim()) {
        target.textContent = source.textContent.trim();
      }
    });
  }

  function scheduleSync() {
    if (syncScheduled) return;

    syncScheduled = true;
    window.requestAnimationFrame(function () {
      syncScheduled = false;
      syncPoints();
    });
  }

  function observeRoot(root) {
    if (observedRoots.indexOf(root) !== -1) return;

    observedRoots.push(root);
    new MutationObserver(scheduleSync).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function initialise() {
    observeRoot(document.documentElement);
    syncPoints();

    var lion = window.loyaltylion || window.lion;
    if (lion && lion.ui && typeof lion.ui.refresh === 'function') {
      lion.ui.refresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
